import { useEffect } from 'react';
import { TrackingClient } from '@sparefoot/tracking-client';
import isBrowser from 'utils/isBrowser';

export default function usePageViewTracking(pageType) {
	useEffect(() => {
		if (isBrowser() && TrackingClient) {
			const metaTitle = document.title || pageType;
			TrackingClient.trackPageView({
				page_name: metaTitle,
				page_type: pageType,
			});
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps
}
